export default __webpack_public_path__ + "static/rent-description-image1-fd4037bb1349a17fbaf8e1293a87284a.jpg";